export default __webpack_public_path__ + "static/media/image.bistec-global-services-pvt-ltd.09251155.png";